export default {"src":"/_next/static/media/georgetown-university.b714d2db.svg","height":24,"width":111,"blurWidth":0,"blurHeight":0};